// extracted by mini-css-extract-plugin
export const root = "page-module--root--PRBZd";
export const loader = "page-module--loader--QPbva";